const cardsData = [
  {
    title: '独家：某流量小生深夜与神秘女子同回公寓，恋情疑似曝光',
    desc: '据目击者透露，两人举止亲密，在小区门口逗留近10分钟后一同进入单元楼。',
    cover: 'https://readdy.ai/api/search-image?query=Night%20urban%20street%20scene%20with%20residential%20building%20entrance%2C%20warm%20street%20lamp%20glow%2C%20mysterious%20atmospheric%20mood%2C%20paparazzi%20style%20photography%2C%20cinematic%20noir%20lighting%20with%20deep%20shadows%2C%20editorial%20photojournalism%20style&width=600&height=400&seq=cards-01&orientation=landscape',
    tag: '独家爆料',
    time: '18分钟前',
    hot: true,
  },
  {
    title: '知名品牌紧急解约代言人，背后黑料浮出水面',
    desc: '三个品牌同时宣布终止合作，据传涉及严重的合同违约与形象损害问题。',
    cover: 'https://readdy.ai/api/search-image?query=Corporate%20brand%20billboard%20being%20removed%20at%20night%2C%20dramatic%20business%20scene%2C%20warm%20street%20lighting%2C%20urban%20commercial%20district%20atmosphere%2C%20editorial%20business%20photography%20with%20strong%20contrast&width=600&height=400&seq=cards-02&orientation=landscape',
    tag: '商业内幕',
    time: '42分钟前',
    hot: true,
  },
  {
    title: '某综艺节目录制现场爆发激烈冲突，多位艺人卷入',
    desc: '现场工作人员爆料称冲突起因是剧本安排引发嘉宾不满，场面一度失控。',
    cover: 'https://readdy.ai/api/search-image?query=Television%20production%20studio%20with%20dramatic%20red%20warning%20lights%2C%20chaotic%20backstage%20atmosphere%2C%20crew%20silhouettes%20in%20tension%2C%20broadcast%20equipment%20and%20cameras%2C%20cinematic%20documentary%20style%20with%20warm%20dramatic%20lighting&width=600&height=400&seq=cards-03&orientation=landscape',
    tag: '综艺翻车',
    time: '1小时前',
    hot: true,
  },
  {
    title: '头部网红被前员工实名举报数据造假，金额惊人',
    desc: '举报材料详细列举了过去两年内的虚假交易记录，涉及金额超过千万。',
    cover: 'https://readdy.ai/api/search-image?query=Digital%20data%20dashboard%20with%20red%20fraud%20alerts%2C%20financial%20documents%20scattered%20on%20desk%2C%20dark%20office%20environment%20with%20dramatic%20lighting%2C%20investigative%20journalism%20mood%2C%20warm%20amber%20and%20crimson%20tones&width=600&height=400&seq=cards-04&orientation=landscape',
    tag: '网红翻车',
    time: '2小时前',
    hot: false,
  },
  {
    title: '某女星被爆在剧组耍大牌耽误拍摄进度，同组演员暗讽',
    desc: '多位群演和工作人员发文内涵，暗指某位女主角态度恶劣导致剧组超期。',
    cover: 'https://readdy.ai/api/search-image?query=Film%20set%20with%20empty%20director%20chair%20and%20abandoned%20equipment%2C%20atmospheric%20movie%20production%20scene%2C%20dramatic%20spotlight%20through%20darkness%2C%20cinematic%20behind%20the%20scenes%20aesthetic%2C%20warm%20and%20shadow%20contrast&width=600&height=400&seq=cards-05&orientation=landscape',
    tag: '片场爆料',
    time: '3小时前',
    hot: false,
  },
  {
    title: '直播界大地震：三大平台联合出手整治虚假宣传',
    desc: '新规要求所有带货主播必须公示产品检测报告，违规者将永久封禁直播间。',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20broadcast%20studio%20with%20prominent%20regulation%20notice%20displayed%2C%20professional%20streaming%20equipment%20setup%2C%20clean%20corporate%20communication%20aesthetic%2C%20warm%20ambient%20lighting%2C%20editorial%20tech%20photography%20style&width=600&height=400&seq=cards-06&orientation=landscape',
    tag: '行业新规',
    time: '4小时前',
    hot: false,
  },
  {
    title: '某上市公司CEO私生活混乱被股东要求下课',
    desc: '内部邮件泄露显示董事会已召开紧急会议讨论CEO去留问题，股价应声下跌。',
    cover: 'https://readdy.ai/api/search-image?query=Corporate%20boardroom%20with%20empty%20CEO%20chair%20at%20head%20of%20table%2C%20dramatic%20overhead%20lighting%2C%20tension%20atmosphere%2C%20business%20crisis%20scene%2C%20editorial%20corporate%20photography%20with%20warm%20wood%20tones%20and%20deep%20shadows&width=600&height=400&seq=cards-07&orientation=landscape',
    tag: '商界八卦',
    time: '5小时前',
    hot: false,
  },
];

export default function SectionCards() {
  return (
    <section id="cards" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[1200px] mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100">
              <i className="ri-newspaper-fill text-primary-500 text-xl"></i>
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              热瓜速递
            </h2>
          </div>
          <span className="text-xs text-foreground-500 bg-background-200 px-3 py-1.5 rounded-full whitespace-nowrap">7条更新</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsData.map((item, idx) => (
            <div
              key={idx}
              className={`bg-background-100 rounded-xl overflow-hidden cursor-pointer group hover:shadow-md transition-shadow duration-300 ${
                idx === 0 ? 'lg:col-span-2 lg:row-span-1' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${idx === 0 ? 'lg:flex lg:h-full' : ''}`}>
                <div className={`relative overflow-hidden ${idx === 0 ? 'lg:w-[45%] shrink-0 aspect-video lg:aspect-auto lg:h-full' : 'aspect-video'}`}>
                  <img
                    src={item.cover}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  {item.hot && (
                    <span className="absolute top-2 left-2 text-xs px-2 py-0.5 rounded-full bg-primary-500 text-background-50 font-medium whitespace-nowrap">
                      热门
                    </span>
                  )}
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500">{item.time}</span>
                  </div>
                  <h3 className={`font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2 ${
                    idx === 0 ? 'text-base md:text-lg' : 'text-sm md:text-base'
                  }`}>
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}